import LotteryNumlotDetailContainer from "../../components/lottery/containers/LotteryNumlotDetailContainer";
import LotteryNumlotDetailTemplate from "../../components/lottery/templates/LotteryNumlotDetailTemplate";
import LotteryLocalNav from "../../components/lottery/LotteryLocalNav";

function Miniloto() {
  return (
    <>
      <LotteryLocalNav placement="mainHeader" lotteryKey="mlt" />
      <section className="min-h-screen">
        <LotteryNumlotDetailContainer lotteryKey="mlt" Template={LotteryNumlotDetailTemplate} />
      </section>
      <LotteryLocalNav placement="mainFooter" lotteryKey="mlt" />
    </>
  );
}
export default Miniloto;
